import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useMyInfo } from '../apollo/auth'
import { contractClient, orpc } from './contract'

/**
 * Claim IDs used across the application
 */
export const ClaimIds = {
  DAILY_CLAIM: 'pixai-daily-credits',
} as const

export const useDailyClaimInfo = () => {
  const { data: me } = useMyInfo()
  return useQuery({
    ...orpc.claim.get.queryOptions({
      input: { id: ClaimIds.DAILY_CLAIM },
    }),
    enabled: Boolean(me),
    // `canClaim` / `claimedAt` are user-scoped — drop cache across
    // login/logout so a returning user doesn't briefly see the previous
    // account's claim status until refetch.
    meta: { dependsOn: ['login'] },
  })
}

export const useClaimClaimMutation = () => {
  const queryClient = useQueryClient()

  const queryKey = orpc.claim.get.queryKey({
    input: { id: ClaimIds.DAILY_CLAIM },
  })

  return useMutation({
    mutationKey: orpc.claim.claim.mutationKey(),
    // The turnstile token is captured at click-time (not hook-render-time), so
    // we can't bake it into `orpc.claim.claim.mutationOptions({ context })`
    // here. Threading the headers through the mutate variables keeps the
    // per-call token flow working with the contract-based client.
    mutationFn: async (vars: {
      id: string
      headers?: Record<string, string>
    }) =>
      contractClient.claim.claim(
        { id: vars.id },
        { context: { headers: vars.headers } },
      ),
    onSuccess: data => {
      queryClient.setQueryData(queryKey, data)
    },
  })
}
